import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=f31ef50e&scoped=true"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"
import style0 from "./Materials.vue?vue&type=style&index=0&id=f31ef50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31ef50e",
  null
  
)

export default component.exports